module.exports = __webpack_public_path__ + "img/fajo-logo-2.328291ed.png";